import React, { useState } from 'react';
import './admin.css';
import  API_BASE  from "../api/api";

const Addbook = () => {
  const [formData, setFormData] = useState({
    title: '',
    price: '',
    description: '',
    highlights: ''
  });

  const [mainImage, setMainImage] = useState(null);
  const [subImages, setSubImages] = useState([]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMainImageChange = (e) => {
    setMainImage(e.target.files[0]);
  };

  const handleAddSubImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSubImages((prev) => [...prev, file]);
    }
  };

  const removeSubImage = (index) => {
    setSubImages((prev) => prev.filter((_, i) => i !== index));
  };



const handleSubmit = async (e) => {
  e.preventDefault();

  const data = new FormData();

  data.append('title', formData.title);
  data.append('price', formData.price);
  data.append('description', formData.description);

  // 🔥 convert highlights → JSON array
  const highlightsArray = formData.highlights
    .split(',')
    .map(h => h.trim())
    .filter(Boolean);

  data.append('highlights', JSON.stringify(highlightsArray));

  if (mainImage) {
    data.append('image', mainImage);
  }

  subImages.forEach((file) => {
    data.append('sub_images[]', file);
  });

  try {
    const res = await fetch(`${API_BASE}/book.php`, {
      method: 'POST',
      body: data,
      credentials: "include" // 🔥 VERY IMPORTANT
    });

    const result = await res.json();

    alert(result.message);

    if (result.status === "success") {

      setFormData({
        title: '',
        price: '',
        description: '',
        highlights: ''
      });

      setMainImage(null);
      setSubImages([]);

      document.querySelectorAll('input[type="file"]').forEach(input => input.value = '');
    }

  } catch (err) {
    console.error(err);
    alert("Error submitting book.");
  }
};

  return (
    <div className="addbook-container">
  <h1 className="dashboard-title">Add Book</h1>
      <form onSubmit={handleSubmit} encType="multipart/form-data" className="addbook-form">

        <input
          type="text"
          name="title"
          placeholder="Book Title"
          value={formData.title}
          onChange={handleChange}
          required
        />
        <input
          type="number"
          name="price"
          placeholder="Book Price"
          value={formData.price}
          onChange={handleChange}
          required
        />
        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
          rows={3}
          required
        />
        <textarea
          name="highlights"
          placeholder="Highlights (comma-separated)"
          value={formData.highlights}
          onChange={handleChange}
          rows={2}
        />

        <label>Main Image</label>
        <input type="file" accept="image/*" onChange={handleMainImageChange} required />

        <label>Add Sub Image (in order)</label>
        <input type="file" accept="image/*" onChange={handleAddSubImage} />

        <div className="subimage-preview-list">
          {subImages.map((img, index) => (
            <div key={index} className="subimage-preview-item">
              <img src={URL.createObjectURL(img)} alt={`Sub ${index + 1}`} />
              <button type="button" onClick={() => removeSubImage(index)}>Remove</button>
            </div>
          ))}
        </div>

        <button type="submit">Add Book</button>
      </form>
    </div>
  );
};

export default Addbook;
